import { Link, useLocation } from "react-router-dom";
import { Home, Ear, Video, Calendar, Phone } from "lucide-react";

const navItems = [
  { icon: Home, label: "Home", href: "/" },
  { icon: Ear, label: "CI Center", href: "/cochlear-implant" },
  { icon: Video, label: "Videos", href: "/videos" },
  { icon: Calendar, label: "Book", href: "/book-appointment" },
];

export default function MobileBottomNav() {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 md:hidden" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around py-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.href;
          return (
            <Link
              key={item.label}
              to={item.href}
              className={`flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-colors ${
                isActive ? 'text-sky-600' : 'text-slate-500'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <item.icon className="w-5 h-5" />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
        <a
          href="tel:+919910317286"
          className="flex flex-col items-center gap-1 px-4 py-2 text-amber-600"
          data-testid="mobile-nav-call"
        >
          <Phone className="w-5 h-5" />
          <span className="text-xs font-medium">Call</span>
        </a>
      </div>
    </nav>
  );
}
